import { GeoJsonObject } from 'geojson'
import * as React from 'react'

import FeatureLayer from 'src/components/map/feature_layer/feature_layer'
import { IMapGeoJsonLayer } from 'src/interfaces/map'

interface IProps {
  layers: IMapGeoJsonLayer[];
}

/**
 * The projects on the overview map. Each one draws what its GeoJSON says, leaves out the features
 * whose zoom range excludes the current zoom, and falls back to a single point where that leaves
 * it with nothing to show.
 */
const GeoJsonLayerCollection: React.FC<IProps> = ({ layers }) => (
  <>
    {layers.map((layer) => (
      <FeatureLayer
        key={layer.id}
        geojson={layer.geojson as GeoJsonObject}
        url={layer.url}
        standInWhenEmpty
      />
    ))}
  </>
)

export default GeoJsonLayerCollection
